export const indexExists = (arrayIndex: number): boolean => arrayIndex >= 0;

export const compact = <T>(list: T[]): T[] => list.filter((item) => item != null);
